"use client";
import { useState, type ReactNode } from "react";
import type { EvidenceFilter } from "../../data";
import { EvidenceFilterContext } from "../../hooks";

interface EvidenceFilterProviderProps {
  children: ReactNode;
}

// Holds the page-wide evidence filter: the filter bar in "How to read this
// page" sets it, and every evidence card further down dims when it doesn't
// match (the preview's `main[data-show]`).
const EvidenceFilterProvider = ({ children }: EvidenceFilterProviderProps) => {
  const initialState: { show: EvidenceFilter } = { show: "all" };
  const [state, setState] = useState(initialState);

  const setShow = (show: EvidenceFilter) =>
    setState((state) => ({ ...state, show }));

  return (
    <EvidenceFilterContext.Provider value={{ show: state.show, setShow }}>
      {children}
    </EvidenceFilterContext.Provider>
  );
};

export default EvidenceFilterProvider;
